<template>
  <FC2
    :id="id"
    :label="label"
    :fcType="'fc2-checkbox'"
    :height="height"
    :textarea="textarea"
    :bb="bb"
    :valued="valued"
    :lw="lw"
  >
    <div
      class="dt-checkbox-container ut-colcen"
      :style="{
        paddingLeft: '10px'
    }"
    >
      <div class="dt-checkbox v2 s1" >
        <input
          type="checkbox"
          @click="e => emit('input', e, ['target', 'checked'])"
          :name="id"
          :id="id"
          :checked="value == '1'"
          :disabled="disabled"
        />
        <div class="checkmark"></div>
      </div>
    </div>
  </FC2>
</template>
<script>
import { toSnakeCase, uuidv4 } from "../../utility";
import FC2 from "../fc2/fc2";
import { FC2Mixin } from "../fc2";

export default {
  components: {
    FC2,
  },
  props: {},
  mixins: [FC2Mixin()],
  mounted: function () {},
  computed: {},
  data: function () {
    return {
      _id: uuidv4(),
      
    };
  },
  methods: {},
};
</script>
<style lang="scss">
.fc2-checkbox {

  input {
    &:disabled {
      opacity: 0.5;
    }
  }
}
</style>